
/* Solid fills — avatar bars, count badges, the active Approvals tab. */
export const PENDING_SOLID       = 'bg-amber-600';
export const PENDING_SOLID_HOVER = 'hover:bg-amber-700';

/* The employee modal header for a pending record. */
export const PENDING_GRADIENT = 'bg-gradient-to-br from-amber-600 to-amber-700';

/* Soft surfaces — chips, banners, tinted rows. */
export const PENDING_SOFT_BG     = 'bg-amber-50';
export const PENDING_SOFT_BG_ALT = 'bg-amber-100';
export const PENDING_BORDER      = 'border-amber-200';

/* Text on a soft surface. */
export const PENDING_TEXT        = 'text-amber-700';
export const PENDING_TEXT_STRONG = 'text-amber-900';

/* Ready-made combinations, so a chip is identical wherever it appears. */
export const PENDING_CHIP =
  'bg-amber-50 text-amber-700 border border-amber-200';

export const PENDING_CHIP_SOLID =
  'bg-amber-100 text-amber-700';

/* An outline control that fills in on hover (the table's "Review" button). */
export const PENDING_OUTLINE_BTN =
  'text-amber-700 bg-amber-50 border border-amber-200 ' +
  'hover:bg-amber-600 hover:text-white hover:border-amber-600';